export default "__VITE_ASSET__BF_Tyxfb__"